<template>
  <div
    class="autocomplete-form"
    @keydown.down="selectedIndex = selectedIndex < valuesShowing.length - 1 ? selectedIndex + 1 : selectedIndex;"
    @keydown.up="selectedIndex = selectedIndex > - 1 ? selectedIndex - 1 : selectedIndex;"
    @keydown.enter="onEnterClicked"
    @focusin="visible=true"
    @focusout="onFocusOut"
  >
    <div class="autocomplete-form-input-elements">
      <input
        id="autocomplete-form-input"
        autocomplete="off"
        class="w-100"
        @input="onInputHandler"
        v-model="text"
        type="text"
      />
    </div>
    <div
      v-if="text.length > 0"
      class="list-group list-group-flush autocomplete-form-items"
      :class="{hide: !visible}"
    >
      <!-- is loading -->
      <div
        v-if="loadingParts"
        class="list-group-item list-group-item-action autocomplete-form-item"
      >
        <b-spinner variant="primary" label="Spinning"></b-spinner>Loading..
      </div>
      <!-- is loaded -->
      <div
        v-for="(val,index) in valuesShowing"
        :key="index"
        :data-id="index"
        class="list-group-item list-group-item-action autocomplete-form-item"
        style="cursor: pointer"
        :class="{active:selectedIndex == index}"
        @click="onClickHandler"
        @mouseover="selectedIndex = index"
      >
      <!-- part description -->
        <div class="d-flex flex-column">
          <!-- top row -->
          <div class="d-flex flex-row justify-content-between flex-nowrap overflow-hidden">
            <label
              style="cursor: inherit"
              class="text-nowrap px-1 font-weight-bold"
            >{{val.part_number}}</label>
            <label style="cursor: inherit" class="text-nowrap px-1">{{val.description}} </label>
            
          </div>
          <!-- bottom row -->
          <div class="d-flex flex-row justify-content-between flex-nowrap overflow-hidden">
           <label style="cursor: inherit; flex-grow:10; text-align: left;" class="text-nowrap px-1" >{{val.quantity}} in stock</label>
           <label style="cursor: inherit; flex-grow:1; text-align: right;" class="text-nowrap px-1" >retail: ${{val.retail_price}}</label>
           <label style="cursor: inherit; flex-grow:1; text-align: right;" class="text-nowrap px-1" >dealer: ${{val.dealer_price}}</label>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { partSearchRequest } from "../requests";
export default {
  name: "parts-input",
  props: {
    value: String
  },
  data() {
    return {
      text: "",
      valuesShowing: [],
      visible: false,
      selectedIndex: 0,
      loadingParts: false
    };
  },
  methods: {
    onInputHandler(e) {
      this.$data.valuesShowing = [];
      this.$data.loadingParts = true;
      partSearchRequest(this.$store.state.app.token, e.target.value).then(
        res => {
          this.$data.valuesShowing = res.data;
          this.$data.loadingParts = false;
        }
      );
      this.$emit("input", this.$data.text);
    },
    onClickHandler(e) {
      this.$data.text = this.$data.valuesShowing[
        this.selectedIndex
      ].part_number;
      this.$data.valuesShowing = [];
      this.$emit("input", this.$data.text);
      e.target.blur();
    },
    onEnterClicked(e) {
      this.$data.text = this.$data.valuesShowing[
        this.$data.selectedIndex
      ].part_number;
      this.$emit("input", this.$data.text);
      e.target.blur();
    },
    onFocusOut(e) {
      //wait for button input
      setTimeout(
        function() {
          this.visible = false;
          this.selectedIndex = 0;
        }.bind(this),
        200
      );
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.$data.text = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.autocomplete-form {
  width: 100%;
  &-input-elements {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
  }

  &-items {
    position: absolute;
    width: 90%;

    border: {
      width: 1px;
      style: solid;
      color: lightgrey;
    }
  }

  &-item {
    z-index: 10;
  }

  input {
    margin-bottom: 1px;
  }
  .hide {
    display: none;
  }
}
</style>